import { render, staticRenderFns } from "./experimental-version.vue?vue&type=template&id=4661f727"
import script from "./experimental-version.vue?vue&type=script&lang=ts"
export * from "./experimental-version.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports